import { getActionTypes } from '../../../HelperMethods/UtilityFunctions';

const types = getActionTypes('contactManagement')([
  'SET_LOADER',
  'LOAD_CONTACTS',
  'UPSERT_CONTACT',
  'DELETE_CONTACT',
  'SET_FORM_LOADER',
]);

export function loadContact(contacts) {
  return { type: types.LOAD_CONTACTS, contacts };
}

export function setLoader(loader) {
  return { type: types.SET_LOADER, loader };
}

export function setFormLoader(loader) {
  return { type: types.SET_FORM_LOADER, loader };
}

export function upsertContact(contact) {
  return { type: types.UPSERT_CONTACT, contact };
}

export function deleteContact(contact) {
  return { type: types.DELETE_CONTACT, contactId: contact.id };
}

export default function contactReducer(
  state = { isContactPageLoading: true, contacts: [], isContactFormLoading: false },
  action
) {
  switch (action.type) {
    case types.SET_LOADER: {
      return { ...state, isContactPageLoading: action.loader };
    }
    case types.SET_FORM_LOADER: {
      return { ...state, isContactFormLoading: action.loader };
    }
    case types.LOAD_CONTACTS: {
      return { ...state, contacts: action.contacts };
    }
    case types.DELETE_CONTACT: {
      return {
        ...state,
        contacts: state.contacts.filter(({ id: contactId }) => contactId !== action.contactId),
      };
    }
    case types.UPSERT_CONTACT: {
      const { contact } = action;
      return {
        ...state,
        contacts: [...state.contacts.filter(({ id: contactId }) => contactId !== contact.id), contact],
      };
    }
    default:
      return state;
  }
}
